import React, { Fragment, useState, useRef, useCallback } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Redirect } from "react-router-dom";
import { createArticle } from "../../actions/article";

import LoggedInNav from "../layout/IME/LoggedInNav";

import { createReactEditorJS } from "react-editor-js";
import { EDITOR_JS_TOOLS } from "../EditorTools/Tools";

import EditorJSError from "../layout/IME/EditorJSError";

const CreateArticle = ({
  auth: { user },
  isAuthenticated,
  createArticle,
  article: { article },
}) => {
  const ReactEditorJS = createReactEditorJS();

  const [file, setFile] = useState("");
  const [dataFile, setDataFile] = useState("");
  const [articletitle, setArticleTitle] = useState("");
  const [keywordText, setKeyword] = useState("");
  const [keywordsText, setKeywords] = useState([]);
  const [articleError, setShowArticleError] = useState({
    show: false,
    text: "",
  });

  const inputRef = useRef(null);
  const editorJS = useRef(null);

  const handleInitialize = useCallback((instance) => {
    editorJS.current = instance;
  }, []);

  const handleSave = useCallback(async () => {
    const savedData = await editorJS.current.save();

    if (savedData.blocks.length > 0) {
      await createArticle(articletitle, keywordsText, savedData, dataFile);
    } else {
      setShowArticleError({
        show: true,
        text: "Please enter text or images into the article body.",
      });
    }
  }, [dataFile, articletitle, keywordsText]);

  if (article.msg === "Success") {
    return <Redirect to={`/${user.channelid}/articles`} />;
  }

  // if (!isAuthenticated) {
  //   return <Redirect to="/" />;
  // } else if (isAuthenticated && user && user.channelid !== "roland") {
  //   return <Redirect to="/" />;
  // }

  return (
    <Fragment>
      {articleError.show && (
        <EditorJSError
          user={user}
          setShowArticleError={setShowArticleError}
          articleError={articleError}
        />
      )}
      <LoggedInNav />
      <form
        method="POST"
        className="flex-all-content-fixed"
        onSubmit={(e) => {
          e.preventDefault();
          handleSave();
        }}
      >
        <section className="main-body-article">
          <div className="create-article">
            {file === "" ? (
              <div className="create-article-container">
                <label htmlFor="articleImage" className="setup-image-container">
                  <div className="create-image-icons green">
                    <i className="fas fa-plus fa-lg green"></i>
                    <i className="fas fa-image fa-4x mx-5 green"></i>
                  </div>
                </label>
                <input
                  type="file"
                  name="articleImage"
                  id="articleImage"
                  className="file-upload green"
                  onChange={(e) => {
                    setFile(URL.createObjectURL(e.target.files[0]));
                    setDataFile(e.target.files[0]);
                  }}
                />
              </div>
            ) : (
              <div className="create-article-container">
                <label htmlFor="articleImage" className="setup-image-container">
                  <div className="article-media-container">
                    <img className="article-media" src={file} />
                    <input
                      type="file"
                      name="articleImage"
                      id="articleImage"
                      className="file-upload"
                      onChange={(e) => {
                        setFile(URL.createObjectURL(e.target.files[0]));
                        setDataFile(e.target.files[0]);
                      }}
                    />
                  </div>
                </label>
              </div>
            )}
          </div>
          <div className="items-container-article">
            <div className="sub-section-container-alt">
              <div className="flex-only">
                <p className="sub-section green">Article Title</p>
              </div>
              <div className="input-label-container">
                <label htmlFor="articletitle" className="labels-input green">
                  *Article Title:
                </label>
                <input
                  type="text"
                  name="articletitle"
                  value={articletitle}
                  className="input-item"
                  placeholder="Enter article title"
                  onChange={(e) => setArticleTitle(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="items-container-article">
            <div className="sub-section-container-alt">
              <div className="flex-only">
                <p className="sub-section green">Keywords</p>
              </div>
              <div className="input-label-container">
                <label htmlFor="keywords" className="labels-input green">
                  Enter a Keyword:
                </label>
                <input
                  type="text"
                  ref={inputRef}
                  name="keywords"
                  value={keywordText}
                  className="input-item"
                  placeholder="Enter a Keyword"
                  onChange={(e) => setKeyword(e.target.value)}
                />
                {keywordText !== "" && (
                  <div
                    className="add-keyword background-green"
                    onClick={() => {
                      setKeywords([...keywordsText, keywordText]);
                      setKeyword("");
                      inputRef.current.focus();
                    }}
                  >
                    Add Keyword
                  </div>
                )}
              </div>
              {keywordsText.map((word, index) => {
                return (
                  <li className="keywordsArray green" key={index}>
                    {word}
                    <i
                      className="fas fa-times fa-sm white times-sm mx-10"
                      onClick={() => {
                        keywordsText.splice(index, 1);
                        setKeywords([...keywordsText]);
                      }}
                    ></i>
                  </li>
                );
              })}
            </div>
          </div>
          <div className="items-container-article">
            <div>
              <div className="flex-only">
                <p className="sub-section-alt green">Article Body</p>
              </div>
              <div className="input-label-container-alt">
                <label htmlFor="articlebody" className="labels-input green">
                  *Article Body:
                </label>
              </div>
              <ReactEditorJS
                holder="custom"
                onInitialize={handleInitialize}
                tools={EDITOR_JS_TOOLS}
              >
                {" "}
                <div id="custom" className="edit-article white" />
              </ReactEditorJS>
            </div>
          </div>
        </section>
        {file !== "" && (
          <div className="submit-changes">
            <button
              className="submit-changes-button background-green"
              onSubmit={() => {
                handleSave();
              }}
            >
              Create Article
            </button>
          </div>
        )}
      </form>
    </Fragment>
  );
};

CreateArticle.propTypes = {
  auth: PropTypes.object.isRequired,
  isAuthenticated: PropTypes.bool,
  createArticle: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  isAuthenticated: state.auth.isAuthenticated,
  article: state.article,
});

export default connect(mapStateToProps, { createArticle })(CreateArticle);
